import { ActivityLogTab } from "@features/ax/shared/ActivityLog";
import { NotesTab } from "@features/ax/shared/NotesTab";
import { Tabs } from "@shared/ui/tabs";
import { useParams } from "react-router-dom";
import { useGetSystemDataById } from "../../hooks";
import { KeyMetricsRow } from "./keyMetricsDashboard";
import { KeyStatsCard } from "./keyStatsDetails";
import { QuickActionsSidebar } from "./quickActionsCard";
import { SystemProfileCard } from "./systemsDetails";
import { AlertsLanding } from "./tabs/alerts/landing";
import { AssetsLanding } from "./tabs/assets/landing";
import { ComplianceLanding } from "./tabs/compliance/landing";
import { ConditionAndRiskLanding } from "./tabs/conditionAndRisk/landing";
import { FilesLanding } from "./tabs/files/landing";
import { FinanceLanding } from "./tabs/finance/landing";
import { PerformanceLanding } from "./tabs/performance/landing";
import { ScheduleLanding } from "./tabs/schedule/landing";
import { ServiceOrderLanding } from "./tabs/serviceOrder/landing";

const urlMapping = {
  performance: "performance",
  alerts: "alerts",
  finance: "finance",
  compliance: "compliance",
  assets: "assets",
  conditionsAndRisk: "conditions-and-risk",
  schedule: "schedule",
  oAndM: "o-and-m",
  files: "files",
  notes: "notes",
  activityLog: "activity-log",
};
export default function SystemsDetailsLanding() {
  const { systemId } = useParams();
  const source = "2";
  const { data: systemData } = useGetSystemDataById(Number(systemId));

  const tabComponents = {
    performance: {
      label: "Performance",
      shortLabel: "Performance",
      component: <PerformanceLanding />,
    },
    alerts: {
      label: "Alerts",
      shortLabel: "Alerts",
      component: <AlertsLanding />,
    },
    finance: {
      label: "Finance",
      shortLabel: "Finance",
      component: <FinanceLanding />,
    },
    compliance: {
      label: "Compliance",
      shortLabel: "Compliance",
      component: <ComplianceLanding />,
    },
    assets: {
      label: "Assets",
      shortLabel: "Assets",
      component: <AssetsLanding />,
    },
    conditionsAndRisk: {
      label: "Conditions & Risk",
      shortLabel: "Conditions & Risk",
      component: <ConditionAndRiskLanding systemData={systemData} />,
    },
    schedule: {
      label: "Schedule",
      shortLabel: "Schedule",
      component: <ScheduleLanding />,
    },
    oAndM: {
      label: "O&M",
      shortLabel: "O&M",
      component: <ServiceOrderLanding />,
    },
    files: {
      label: "Files & Documents",
      shortLabel: "Files",
      component: <FilesLanding systemData={systemData} />,
    },
    notes: {
      label: "Notes",
      component: (
        <NotesTab requestId={systemId} source={source} title="System" />
      ),
    },
    activityLog: {
      label: "Activity Log",
      shortLabel: "Activity Log",
      component: <ActivityLogTab entityId={systemId} entityType={source} />,
    },
  };
  return (
    <div className="p-4">
      <div className="space-y-6">
        <div className="space-y-6">
          <div className="grid grid-cols-12 lg:grid-cols-12 gap-6">
            <div className="lg:col-span-8 space-y-6">
              <SystemProfileCard data={systemData} />
              <KeyMetricsRow data={systemData} />
            </div>
            <div className="lg:col-span-4 space-y-4">
              <KeyStatsCard data={systemData} />
              <QuickActionsSidebar data={systemData} />
            </div>
          </div>
          <Tabs
            defaultValue="performance"
            urlMapping={urlMapping}
            tabComponents={tabComponents}
            tabsListClassName="grid w-full grid-cols-11 mb-6"
            idPrefix="settings-tab"
            level={0}
          />
        </div>
      </div>
    </div>
  );
}
